<template>
    <auth-card class="failed-to-load-captcha">
        <p class="failed-to-load-captcha-text">{{ $t("login.invalid-captcha") }}</p>

        <auth-button
            @click="reloadPage"
            text="reload"
        />
    </auth-card>
</template>

<script>
import AuthCard from "./base/AuthCard.vue";
import AuthButton from "./base/AuthButton.vue";
import { reloadPage } from "../../utils/DOM";

export default {
    name: "FailedToLoadCaptcha",
    components: { AuthButton, AuthCard },
    methods: {
        reloadPage
    }
}
</script>

<style scoped>

</style>